import ErrorPage from './error-page'

export default function ForbiddenError() {
  return (
    <ErrorPage title="⛔ Access Denied">
      We're sorry, but you don't have permission to access this page.
    </ErrorPage>
  )
}
